import React from 'react';
import clsx from 'clsx';

export const Link = ({
  href,
  children,
  type,
  openInNewTab,
  ariaLabel,
  classNames,
}: {
  href: string;
  children: React.ReactNode;
  className?: string;
  type?: 'hyperlink' | 'modal' | 'contrast';
  ariaLabel?: string;
  openInNewTab?: boolean;
  classNames?: string;
}) => (
  <a
    href={href}
    className={clsx(
      'underline cursor-pointer',
      !type && 'text-navy-blue hover:text-action-states-primary-hovered active:text-action-states-primary-pressed',
      type === 'modal' && 'text-nero hover:text-action-states-brand-2-hovered active:text-action-states-brand-2-pressed',
      type === 'contrast' &&
        'text-action-states-tertiary hover:text-action-states-tertiary-hovered active:text-action-states-tertiary-pressed',
      classNames,
    )}
    aria-label={ariaLabel}
    target={openInNewTab ? '_blank' : undefined}
    rel="noopener noreferrer"
  >
    {children}
  </a>
);
